export default "__VITE_ASSET__DYniuMUg__"